import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import {
  ArrowUpIcon,
  ArrowDownIcon,
  ActivityIcon,
  BuildingIcon,
  UsersIcon,
  ZapIcon,
} from "lucide-react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useServiceAreaStats, useMonthlySummary } from "../../../hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";

const DashboardTab = () => {
  const utilityID=useRemoteUtilityId()
  const { data: serviceStats } = useServiceAreaStats();
  const { data: monthlySummary } = useMonthlySummary(utilityID); // pass your remote_utility_id dynamically if needed
console.log("serviceStats:", serviceStats);
  const kpiData = serviceStats
    ? [
        {
          title: "Total Premises",
          count: serviceStats.premiseStats.levelCount,
          trend: serviceStats.premiseStats.percentageChange,
          trendDurationDisplay: 'vs last month',
          icon: <BuildingIcon />,
        },
        {
          title: "Active Consumers",
          count: serviceStats.activeConsumerStats.totalActiveConsumers,
          trend: serviceStats.activeConsumerStats.percentageChange,
          trendDurationDisplay: 'vs last month',

          icon: <UsersIcon/>,
        },
        {
          title: "Active Meters",
          count: serviceStats.assignedMeterStats.totalAssignedMeters,
          trend: serviceStats.assignedMeterStats.percentageChange,
          trendDurationDisplay: 'vs last month',
          
          icon: <ZapIcon />,
        },
        {
          title: "Work Orders",
          count: serviceStats.workorderStats.totalWorkorders,
          trend: serviceStats.workorderStats.percentageChange,
          trendDurationDisplay: 'vs last month',
          icon: <ActivityIcon />,
        },
      ]
    : [];

  const formattedChartData = monthlySummary?.map((item) => ({
    month: item.month.substring(0, 3), // Jan, Feb, etc.
    premises: item.premiseCount,
    consumers: item.installedConsumerCount,
  }));

  return (
    <div className="space-y-6">
      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {kpiData.map((kpi, index) => {
          const IconComponent = kpi.icon;
          return (
            // <Card
            //   key={index}
            //   className="hover:shadow-lg transition-all duration-200 cursor-pointer group"
            // >
            //   <CardContent className="p-4">
            //     <div className="flex items-start justify-between">
            //       <div className="flex-1">
            //         <div className="flex items-center gap-2 mb-2">
            //           <IconComponent className="w-4 h-4 text-gray-600" />
            //           <p className="text-xs font-medium text-gray-600 uppercase tracking-wide">
            //             {kpi.title}
            //           </p>
            //         </div>
            //         <p className="text-xl font-bold text-gray-900 mb-1">
            //           {kpi.value}
            //         </p>
            //         <div className={`flex items-center text-sm ${kpi.color}`}>
            //           {kpi.trend === "up" ? (
            //             <ArrowUpIcon className="w-3 h-3 mr-1" />
            //           ) : (
            //             <ArrowDownIcon className="w-3 h-3 mr-1" />
            //           )}
            //           <span className="font-medium">{kpi.change}%</span>
            //         </div>
            //       </div>
            //     </div>
            //     <p className="text-xs text-gray-500 mt-2">vs last month</p>
            //   </CardContent>
            // </Card>

            <QuickStatsCard {...kpi} />
          );
        })}
      </div>

      {/* Monthly Trends Area Chart */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <ActivityIcon className="w-5 h-5" />
            6-Month Growth Trends
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={formattedChartData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip
                  formatter={(value: number, name: string) => {
                    if (name === "premises")
                      return [`${value} premises`, "Premises"];
                    if (name === "consumers")
                      return [`${value} consumers`, "Consumers"];
                    return [value, name];
                  }}
                />
                <Area
                  type="monotone"
                  dataKey="premises"
                  stackId="1"
                  stroke="#3B82F6"
                  fill="#3B82F6"
                  fillOpacity={0.3}
                />
                <Area
                  type="monotone"
                  dataKey="consumers"
                  stackId="2"
                  stroke="#10B981"
                  fill="#10B981"
                  fillOpacity={0.3}
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DashboardTab;
